// 15个业务模块的菜单与表格列配置(配置驱动,新增模块只需在此加一份配置)
// 列 type 说明:text 文本 | number 数字 | amount 金额(元) | percent 百分比 | date 日期 | datetime 日期时间 | tag 状态标签
export const modules = [
  {
    key: 'farm',
    path: '/farm',
    name: '养殖场模块',
    columns: [
      { prop: 'houseNo', label: '鸡舍编号', width: 100 },
      { prop: 'area', label: '鸡舍面积(㎡)', type: 'number' },
      { prop: 'chickenCount', label: '饲养鸡数(只)', type: 'number' },
      { prop: 'cleanStatus', label: '清洁情况', type: 'tag' },
      { prop: 'temperature', label: '温度(℃)', type: 'number' },
      { prop: 'humidity', label: '湿度(%)', type: 'number' },
      { prop: 'ventilation', label: '通风情况', type: 'tag' },
      { prop: 'lighting', label: '灯光情况', type: 'tag' },
      { prop: 'feedUse', label: '饲料使用情况', minWidth: 160 },
      { prop: 'medicineUse', label: '药品使用情况', minWidth: 140 }
    ]
  },
  {
    key: 'feed',
    path: '/feed',
    name: '饲料管理',
    columns: [
      { prop: 'feedName', label: '饲料名称', width: 140 },
      { prop: 'spec', label: '饲料规格' },
      { prop: 'factory', label: '饲料厂家', width: 130 },
      { prop: 'price', label: '饲料价格(元)', type: 'amount' },
      { prop: 'usage', label: '饲料用量' },
      { prop: 'stock', label: '饲料库存(kg)', type: 'number' },
      { prop: 'inTime', label: '入库时间', type: 'date' },
      { prop: 'expireTime', label: '过期时间', type: 'date' },
      { prop: 'outTime', label: '出库时间', type: 'date' },
      { prop: 'remark', label: '备注', minWidth: 140 }
    ]
  },
  {
    key: 'medicine',
    path: '/medicine',
    name: '药品管理',
    columns: [
      { prop: 'medicineName', label: '药品名称', width: 160 },
      { prop: 'spec', label: '药品规格' },
      { prop: 'factory', label: '药品厂家', width: 130 },
      { prop: 'price', label: '药品价格(元)', type: 'amount' },
      { prop: 'usage', label: '药品用量', minWidth: 130 },
      { prop: 'stock', label: '药品库存', type: 'number' },
      { prop: 'inTime', label: '入库时间', type: 'date' },
      { prop: 'expireTime', label: '过期时间', type: 'date' },
      { prop: 'outTime', label: '出库时间', type: 'date' },
      { prop: 'remark', label: '备注', minWidth: 140 }
    ]
  },
  {
    key: 'purchase',
    path: '/purchase',
    name: '采购管理',
    columns: [
      { prop: 'orderNo', label: '采购单编号', width: 150 },
      { prop: 'purchaseDate', label: '采购日期', type: 'date' },
      { prop: 'supplier', label: '供应商名称', width: 130 },
      { prop: 'goods', label: '采购物品' },
      { prop: 'quantity', label: '采购数量', type: 'number' },
      { prop: 'amount', label: '采购金额(元)', type: 'amount' },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 150 }
    ]
  },
  {
    key: 'production',
    path: '/production',
    name: '生产管理',
    columns: [
      { prop: 'hatchDate', label: '孵化日期', type: 'date' },
      { prop: 'hatchType', label: '孵化种类' },
      { prop: 'hatchCount', label: '孵化数量(只)', type: 'number' },
      { prop: 'successRate', label: '孵化成功率', type: 'percent' },
      { prop: 'health', label: '健康情况', type: 'tag' },
      { prop: 'saleStatus', label: '销售情况', type: 'tag' },
      { prop: 'feeding', label: '喂养情况', type: 'tag' },
      { prop: 'immune', label: '免疫情况', type: 'tag' },
      { prop: 'disease', label: '疾病情况', minWidth: 130 },
      { prop: 'handleWay', label: '处理方式', minWidth: 130 }
    ]
  },
  {
    key: 'sales',
    path: '/sales',
    name: '销售管理',
    columns: [
      { prop: 'orderNo', label: '销售单编号', width: 150 },
      { prop: 'saleDate', label: '销售日期', type: 'date' },
      { prop: 'customer', label: '客户名称', width: 140 },
      { prop: 'goods', label: '销售物品' },
      { prop: 'quantity', label: '销售数量', type: 'number' },
      { prop: 'amount', label: '销售金额(元)', type: 'amount' },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 150 }
    ]
  },
  {
    key: 'warehouse',
    path: '/warehouse',
    name: '进出库管理',
    columns: [
      { prop: 'goodsName', label: '品名', width: 150 },
      { prop: 'quantity', label: '数量', type: 'number' },
      { prop: 'ioFlag', label: '进/出库标志', type: 'tag' },
      { prop: 'ioTime', label: '进/出库时间', type: 'datetime' },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 180 }
    ]
  },
  {
    key: 'check',
    path: '/check',
    name: '日常检查模块',
    columns: [
      { prop: 'checkTime', label: '检查时间', type: 'datetime' },
      { prop: 'checkItem', label: '检查项目', width: 150 },
      { prop: 'checkResult', label: '检查结果', type: 'tag' },
      { prop: 'handleStatus', label: '处理情况', minWidth: 200 },
      { prop: 'recorder', label: '记录人' }
    ]
  },
  {
    key: 'vaccine',
    path: '/vaccine',
    name: '疫苗管理',
    columns: [
      { prop: 'vaccineName', label: '疫苗名称', width: 150 },
      { prop: 'spec', label: '疫苗规格' },
      { prop: 'validDate', label: '有效期', type: 'date' },
      { prop: 'factory', label: '厂家', width: 120 },
      { prop: 'dosage', label: '剂量' },
      { prop: 'injectTime', label: '注射时间', type: 'datetime' },
      { prop: 'injectPart', label: '注射部位' },
      { prop: 'immuneStatus', label: '免疫情况', type: 'tag' },
      { prop: 'handler', label: '经手人' }
    ]
  },
  {
    key: 'egg',
    path: '/egg',
    name: '鸡蛋管理',
    columns: [
      { prop: 'eggNo', label: '鸡蛋编号', width: 140 },
      { prop: 'layTime', label: '下蛋时间', type: 'datetime' },
      { prop: 'houseNo', label: '鸡舍编号', width: 100 },
      { prop: 'storeTime', label: '储存时间', type: 'datetime' },
      { prop: 'saleStatus', label: '销售情况', type: 'tag' },
      { prop: 'qualityCheck', label: '质量检测', type: 'tag' },
      { prop: 'handler', label: '经手人' }
    ]
  },
  {
    key: 'breed',
    path: '/breed',
    name: '种鸡购买模块',
    columns: [
      { prop: 'orderNo', label: '购买单号', width: 150 },
      { prop: 'buyDate', label: '购买日期', type: 'date' },
      { prop: 'breedType', label: '种鸡种类', width: 150 },
      { prop: 'quantity', label: '数量(只)', type: 'number' },
      { prop: 'price', label: '售价(元)', type: 'amount' },
      { prop: 'supplier', label: '供应商', width: 130 },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 150 }
    ]
  },
  {
    key: 'clean',
    path: '/clean',
    name: '鸡舍清洁模块',
    columns: [
      { prop: 'cleanTime', label: '清洁时间', type: 'datetime' },
      { prop: 'houseNo', label: '鸡舍编号', width: 110 },
      { prop: 'cleanStatus', label: '清洁情况', type: 'tag' },
      { prop: 'cleaner', label: '清洁人员' },
      { prop: 'remark', label: '备注', minWidth: 200 }
    ]
  },
  {
    key: 'slaughter',
    path: '/slaughter',
    name: '屠宰管理',
    columns: [
      { prop: 'date', label: '屠宰日期', type: 'date' },
      { prop: 'slaughterCount', label: '屠宰数量(只)', type: 'number' },
      { prop: 'productCount', label: '成品数量(kg)', type: 'number' },
      { prop: 'wasteCount', label: '产生废品数量(kg)', type: 'number' },
      { prop: 'worker', label: '屠宰人员' },
      { prop: 'handler', label: '经手人' }
    ]
  },
  {
    key: 'cost',
    path: '/cost',
    name: '成本管理',
    columns: [
      { prop: 'feedCost', label: '饲料成本(元)', type: 'amount' },
      { prop: 'medicineCost', label: '药品成本(元)', type: 'amount' },
      { prop: 'transportCost', label: '运输成本(元)', type: 'amount' },
      { prop: 'laborCost', label: '人工成本(元)', type: 'amount' },
      { prop: 'deviceCost', label: '设备折旧(元)', type: 'amount' },
      { prop: 'otherCost', label: '杂项成本(元)', type: 'amount' },
      { prop: 'totalCost', label: '总成本(元)', type: 'amount' },
      { prop: 'remark', label: '备注', minWidth: 150 }
    ]
  },
  {
    key: 'report',
    path: '/report',
    name: '统计报表模块',
    isGroup: true,
    children: [
      { key: 'salesReport', path: '/report/sales', name: '销售报表' },
      { key: 'stockReport', path: '/report/stock', name: '库存报表' },
      { key: 'ioReport', path: '/report/io', name: '进出库报表' },
      { key: 'financeReport', path: '/report/finance', name: '财务报表' },
      { key: 'diseaseReport', path: '/report/disease', name: '疾病报表' },
      { key: 'productionReport', path: '/report/production', name: '生产报表' },
      { key: 'businessReport', path: '/report/business', name: '经营报表' },
      { key: 'healthReport', path: '/report/health', name: '健康报表' },
      { key: 'yieldReport', path: '/report/yield', name: '亩产报表' },
      { key: 'marketingReport', path: '/report/marketing', name: '营销报表' }
    ]
  }
]

// 根据模块 key 查找配置
export function findModule(key) {
  return modules.find(m => m.key === key)
}
